module.exports = "https://cdn.thelire.com/ins/resource/icon_line_cancel_white.90241b1436aa735ae9515a82794d831f.png";